<template>
    <div id="konfigurator-fotografie">

        <h1>{{ 'Profile picture of the dog' | translate }}<br>
        {{ '(it will be also on the Haffit packaging)' | translate }}</h1>

        <div class="form-content">
            <div v-show="!mazlicek.fotografie.value" style="max-width: 800px" class="form-group icn-img-wrapper">
                <div>
                    <img v-bind:src="mazlicek.fotografie.icnValue"/>
                </div>
            </div>
            <div v-show="mazlicek.fotografie.value" style="max-width: 1000px" class="form-group crop-img-wrapper">
                <a class="close" @click="nechciFotoClick">X</a>
                <div>
                    <vue-croppie
                        ref="croppieRef"
                        :enableResize="false"
                        :enableExif="true"
                        :viewport="{width: viewportSize, height: viewportSize, type: 'square'}"
                        :boundary="{width: boundarySize, height: boundarySize}"
                    >
                    </vue-croppie>
                    <div class="control-buttons">
                        <div>
                            <label style="display:inline-block" for="zoom-in-photo"><span class="button">+</span></label>
                            <label style="display:inline-block" for="zoom-out-photo"><span class="button">-</span></label>
                        </div>
                        <label style="display:inline-block" for="rotate-photo"><span class="button">{{ 'Rotate 90°' | translate }}</span></label>
                    </div>
                    <input style="display:none" type="button" @click="rotate(90)" id="rotate-photo">
                    <input style="display:none" type="button" @click="zoom(1)" id="zoom-in-photo">
                    <input style="display:none" type="button" @click="zoom(-1)" id="zoom-out-photo">
                </div>
            </div>
            <div v-if="!mazlicek.fotografie.value" class="fotografie-nahrat">
                <label for="file-upload-photo"><span class="button">{{ 'Upload your own photo(optional)' | translate }}</span></label>
                <input ref="photoInput" accept="image/*" type="file" @change="setImage" id="file-upload-photo">
            </div>
        </div>

        <info :krok="3"></info>

        <navigace
                :showPrev="true"
                :onClickPrev="prev"
                :showNext="true"
                :onClickNext="next"
                :onClickSaveAndQuit="saveAndQuit"
        ></navigace>


    </div>
</template>

<script>
  /* eslint-disable */

  import {validationMixin} from 'vuelidate'
    import {required} from 'vuelidate/lib/validators'
    import navigace from './Navigace'
    import info from './Info'
    import {apiSilex} from '../api'
    import imageService from '../services/image-service'
    import {apiDrupal} from '../api/index'

    export default {
        name: 'fotografie',
        components: {navigace, info},
        mixins: [validationMixin],
        data: function () {
            return {
                photo: '',
                mazlicek: this.$store.state.mazlicek,
                dummyIco: 'https://dummyimage.com/600x400/000/fff&amp;text=ico',
                cropImage: null,
                rasaItems: null,
                enRasaName: null,
                imgChanged: null,
                url: null,
                cropOptions: null
            }
        },
        computed: {
            boundarySize: function () {
                let paddingHorizontal = 45
                return window.innerWidth < 600 ? window.innerWidth - 2 * paddingHorizontal : 600
            },
            viewportSize: function () {
                let padding = 20
                return window.innerWidth < 600 ? this.boundarySize - 2 * padding : 400
            },
        },
        methods: {
            zoom: function (value){
              this.$refs.croppieRef.get((param) => {
                this.$refs.croppieRef.setZoom(param.zoom + param.zoom * 0.2 * value)
              })
            },
            rotate: function (angle){
              this.$refs.croppieRef.rotate(angle);
            },
            obrazekTyp: function (val) {
                this.mazlicek.fotografie.value = null
            },
            nechciFotoClick: function (e) {
                this.mazlicek.fotografie.typ = 'ikona'
                this.mazlicek.fotografie.value = ''
                this.mazlicek.fotografie.original = ''
                this.mazlicek.fotografie.cropOptions = null
                this.$refs.photoInput.value = null
            },
            prev: function () {
                this.$router.push({name: 'rasa'})
            },
            next: function () {
                if (this.mazlicek.fotografie.typ === 'foto') {
                    let options = {
                        type: 'base64',
                        size: 'viewport',
                        format: 'jpeg',
                        quality: 1,
                        circle: 'false'
                    }
                    this.$refs.croppieRef.get((param) => {
                        this.$refs.croppieRef.setZoom(param.zoom + 0.01)
                    })
                    this.$refs.croppieRef.result(options, (output) => {
                        this.mazlicek.fotografie.value = output
                        this.mazlicek.fotografie.url = this.url
                        this.cropOptions = this.$refs.croppieRef.get()
                        this.mazlicek.fotografie.cropOptions = this.cropOptions
                        this.mazlicek.fotografie.imgCropComplete = true
                        this.updatePet()
                    })
                } else {
                    apiDrupal.get('/pet-remove-img/' + this.mazlicek.nid).then(response => {
                        this.mazlicek.fotografie.value = ''
                        this.mazlicek.fotografie.original = ''
                        this.mazlicek.fotografie.cropOptions = null
                        this.mazlicek.fotografie.url = null
                        this.mazlicek.fotografie.typ = 'ikona'

                        this.updatePet()
                    })
                }
            },
            saveAndQuit : function() {
              if (this.mazlicek.fotografie.typ === 'foto') {
                let options = {
                  type: 'base64',
                  size: 'viewport',
                  format: 'jpeg',
                  quality: 1,
                  circle: 'false'
                }
                this.$refs.croppieRef.get((param) => {
                  this.$refs.croppieRef.setZoom(param.zoom + 0.01)
                })
                this.$refs.croppieRef.result(options, (output) => {
                  this.mazlicek.fotografie.value = output
                  this.mazlicek.fotografie.url = this.url
                  this.cropOptions = this.$refs.croppieRef.get()
                  this.mazlicek.fotografie.cropOptions = this.cropOptions
                  this.mazlicek.fotografie.imgCropComplete = true
                  this.mazlicek.fotografie.valid = true
                  this.$store.dispatch('updatePet', this.mazlicek)
                    .then(response => {
                      window.location.href = 'prihlaseni'
                    }, error => {
                      console.error(error)
                    })
                })
              } else {
                apiDrupal.get('/pet-remove-img/' + this.mazlicek.nid).then(response => {
                  this.mazlicek.fotografie.value = ''
                  this.mazlicek.fotografie.original = ''
                  this.mazlicek.fotografie.cropOptions = null
                  this.mazlicek.fotografie.url = null
                  this.mazlicek.fotografie.typ = 'ikona'

                  this.mazlicek.fotografie.valid = true
                  this.$store.dispatch('updatePet', this.mazlicek)
                    .then(response => {
                      window.location.href = 'prihlaseni'
                    }, error => {
                      console.error(error)
                    })
                })
              }
            },
            setImage(e) {
                this.mazlicek.fotografie.imgCropComplete = false

                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) return;

                var reader = new FileReader();
                reader.onload = e => {
                    this.$refs.croppieRef.bind({
                        url: e.target.result
                    });

                    let image = new Image()

                    image.addEventListener('load', () => {
                        if (image.width < 650 || image.height < 450) {
                            this.$refs.photoInput.value = null
                            alert('Das Bild muss eine Auflösung von mindestens 650 x 450 haben')
                            return
                        }

                        this.mazlicek.fotografie.typ = 'foto'
                        this.mazlicek.fotografie.value = e.target.result
                        this.mazlicek.fotografie.original = e.target.result
                    })

                    image.src = e.target.result
                };

                reader.readAsDataURL(files[0]);

                const file = e.target.files[0]
                if (!file.type.includes('image/')) {
                    this.$refs.photoInput.value = null
                    alert('Vybraný soubor musí být obrázek')
                }
            },
            afterMounted() {

                this.mazlicek.step.current = 3
                this.$cookies.set('lastVisitedStep', 3)
                jQuery('html, body').animate({scrollTop: 0}, '500')

                if (this.mazlicek.fotografie.url) {
                    this.url = this.mazlicek.fotografie.url
                    this.cropOptions = this.mazlicek.fotografie.cropOptions
                    if(this.cropOptions){
                      this.$refs.croppieRef.bind({
                        url: this.url,
                        points: this.cropOptions.points,
                        zoom: this.cropOptions.zoom
                      });
                      this.rotate(360)
                    }
                }
                if (this.mazlicek.rasa.id) {
                    apiSilex.get('/rasa?id=' + this.mazlicek.rasa.id).then((response) => {
                        const val = response.data[0]
                        const _that = this

                        const raceImage = val.rasa_obrazek_url !== ""  ?
                            val.rasa_obrazek_url : imageService.RACE_ORIGINAL_IMAGES_URL + val.title_en + '.png'

                        var xhr = new XMLHttpRequest()

                        xhr.onload = function () {
                            imageService
                                .createBase64Image(xhr.response)
                                .then(base64Image => {
                                    _that.mazlicek.fotografie.icnValue = base64Image
                                })
                        }
                        xhr.open('GET', raceImage)
                        xhr.responseType = 'blob'
                        xhr.send()
                    })
                } else if(this.mazlicek.rasa.velikost) {
                    const _that = this
                    // const raceImage = imageService.SIZE_ORIGINAL_IMAGES_URL + 'size-' + this.mazlicek.rasa.velikost + '.png'

                    const raceImage = imageService.SIZE_ORIGINAL_IMAGES_URL + 'size-new-' + this.mazlicek.rasa.velikost + '.svg'

                    var xhr = new XMLHttpRequest()

                    xhr.onload = function () {
                        imageService
                            .createBase64Image(xhr.response)
                            .then(base64Image => {
                                _that.mazlicek.fotografie.icnValue = base64Image
                            })
                    }
                    xhr.open('GET', raceImage)
                    xhr.responseType = 'blob'
                    xhr.send()
                }
            },
            updatePet() {
                this.mazlicek.fotografie.valid = true
                this.$store.dispatch('updatePet', this.mazlicek)
                    .then(response => {
                        this.$router.push({name: 'narozeniny'})
                    }, error => {
                        console.error(error)
                    })
            }
        },
        mounted: function () {
            this.afterMounted()
        },
        watch: {
            'mazlicek.petLoaded': {
                deep: true,
                handler: function (val) {
                    if (val.value)
                        this.afterMounted()
                }
            },
            'mazlicek.fotografie.value': {
                deep: true,
                handler: function (val) {
//                    this.$refs.croppieRef.bind({
//                        url: 'http://i.imgur.com/miVkBH2.jpg',
//                    });
                }
            },
//             'mazlicek.petLoaded': {
//                 deep: true,
//                 handler: function (val) {
// //                    console.log(this.url)
//                     if (this.mazlicek.fotografie.url) {
//                         this.url = this.mazlicek.fotografie.url
//                         this.cropOptions = this.mazlicek.fotografie.cropOptions
//                         this.$refs.croppieRef.bind({
//                             url: this.url,
//                             points: this.cropOptions.points,
//                             zoom: this.cropOptions.zoom
//                         });
//                     }
//                 }
//             }
        }
    }
</script>
<style>
    .cr-slider {
        display: none !important;
    }
</style>



// WEBPACK FOOTER //
// 03Fotografie.vue?d5812282